import * as _ from "lodash";

export class GuestListItem {
  constructor(date, venueDetailsId) {
    this.id = undefined;
    this.guestListItemId = { id: this.id };
    this.date = date;
    this.note = '';
    this.rejectionNote = undefined;
    this.type = undefined;
    this.created = undefined;
    this.createdBy = undefined;
    this.updated = undefined;
    this.updatedBy = undefined;
    this.deleted = undefined;
    this.guestProfileId = undefined;
    this.venueDetailsId = venueDetailsId;
    this.fullName = undefined;
    this.email = undefined;
    this.phoneNumber = undefined;
    this.guestCount = 1;
    this.requestState = undefined;
    this.arrivalState = undefined;
    this.arrivals = undefined
  }

  isValid() {
    let valid = !!this.date && !!this.venueDetailsId &&
      !!this.fullName && !!this.fullName.trim()

    let numbersValid = this.guestCount >= 1;

    valid = valid && numbersValid;
    return valid;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    const item = Object.assign(new GuestListItem(), json);
    return item;
  }
}

export class GUEST_LIST_ITEM_REQUEST_STATE {
  static Approved = 0;
  static Requested = 10;
  static Rejected = 20;

  static nameof(state) {
    switch (state) {
      case GUEST_LIST_ITEM_REQUEST_STATE.CreatedByBackend: {
        return 'Created by backend';
      }
      case GUEST_LIST_ITEM_REQUEST_STATE.Requested: {
        return 'Requested';
      }
      case GUEST_LIST_ITEM_REQUEST_STATE.Approved: {
        return 'Approved';
      }
      case GUEST_LIST_ITEM_REQUEST_STATE.Rejected: {
        return 'Rejected';
      }
    }
  }

  static getAll() {
    return [GUEST_LIST_ITEM_REQUEST_STATE.NotArrived, GUEST_LIST_ITEM_REQUEST_STATE.Requested, GUEST_LIST_ITEM_REQUEST_STATE.Approved, GUEST_LIST_ITEM_REQUEST_STATE.Rejected];
  }
}

export class GUEST_LIST_ITEM_ARRIVAL_STATE {
  static NotArrived = 0;
  static ArrivedAndAccepted = 10;
  static ArrivedAndRejected = 20;

  // Only used to show in drop down
  static PartialArrival = 40

  static nameof(state) {
    switch (state) {
      case GUEST_LIST_ITEM_ARRIVAL_STATE.NotArrived: {
        return 'Not arrived';
      }
      case GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndAccepted: {
        return 'Arrived';
      }
      case GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndRejected: {
        return 'Reject on arrival';
      }
      case GUEST_LIST_ITEM_ARRIVAL_STATE.PartialArrival: {
        return 'Partial arrival';
      }
    }
  }

  static iconof(state) {
    switch (state) {
      case GUEST_LIST_ITEM_ARRIVAL_STATE.NotArrived: {
        return 'CircleIcon';
      }
      case GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndAccepted: {
        return 'CheckCircleIcon';
      }
      case GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndRejected: {
        return 'ThumbsDownIcon';
      }
      case GUEST_LIST_ITEM_ARRIVAL_STATE.PartialArrival: {
        return 'UsersIcon';
      }
    }
  }

  static getAll() {
    return [GUEST_LIST_ITEM_ARRIVAL_STATE.NotArrived, GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndAccepted, GUEST_LIST_ITEM_ARRIVAL_STATE.PartialArrival, GUEST_LIST_ITEM_ARRIVAL_STATE.ArrivedAndRejected];
  }
}
